import { FunctionComponent, ReactElement, Suspense } from 'react'

import { DialogProps } from '@radix-ui/react-dialog'

import { Dialog, DialogContent, DialogContentProps } from '@/shared/ui/Dialog'

import { ModalContext } from '../Modal'

interface ExtendedProps {
	isOpen: boolean
	onClose: () => void
	children?: ReactElement
	modalContentProps?: DialogContentProps
	modalProps?: Omit<DialogProps, 'open' | 'onOpenChange'>
}

export const withModal =
	<BaseProps extends NonNullable<unknown>>(
		Component: FunctionComponent<BaseProps>,
		FallbackComponent: FunctionComponent<unknown>
	): FunctionComponent<Omit<BaseProps, 'onDirty'> & ExtendedProps> =>
	// eslint-disable-next-line react/display-name
	({
		isOpen,
		onClose,
		children,
		modalContentProps,
		modalProps,
		...props
	}: Omit<BaseProps, 'onDirty'> & ExtendedProps) => {
		return (
			<ModalContext.Provider value={{ isOpen, onClose }}>
				<Dialog
					open={isOpen}
					onOpenChange={open => {
						if (!open) onClose()
					}}
					{...modalProps}
				>
					<DialogContent {...modalContentProps}>
						<Suspense fallback={<FallbackComponent />}>
							<Component
								onClose={onClose}
								// TODO: Remove as unknown
								{...(props as unknown as BaseProps)}
							/>
						</Suspense>
						{children}
					</DialogContent>
				</Dialog>
			</ModalContext.Provider>
		)
	}
